import React from 'react';
import { Tooltip } from './Tooltip';

interface ValidatedInputProps {
    type?: string;
    value: number;
    onChange: (value: number) => void;
    error?: string;
    label: string;
    tooltip?: string;
    step?: string;
    min?: string;
    max?: string;
}

export const ValidatedInput: React.FC<ValidatedInputProps> = ({
    type = "number",
    value,
    onChange,
    error,
    label,
    tooltip,
    step,
    min,
    max
}) => {
    const inputId = `input-${label.toLowerCase().replace(/\s+/g, '-')}`;

    return (
        <div className="control-item">
            <label htmlFor={inputId} className={error ? 'error-label' : ''}>
                {label}
                {tooltip && <Tooltip content={tooltip} />}
            </label>
            <input
                id={inputId}
                type={type}
                value={value}
                onChange={(e) => onChange(Number(e.target.value))}
                className={error ? 'input-error' : ''}
                step={step}
                min={min}
                max={max}
            />
            {error && <div className="field-error">{error}</div>}
        </div>
    );
};